import { render } from "./TermsAndConditions.vue?vue&type=template&id=1c2ca56a"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__